<template>
    <!-- <div class="model-box ptn clear coach-list">
        <avatar-card v-for="(item,index) in list" :key="item.id" :coachInfo="item"></avatar-card>
    </div> -->

    <div class="model-box bcw ptn clear coach-list">
        <coach-card-new v-for="(item,index) in list" :key="index" :coachInfo="item"></coach-card-new>
    </div>
</template>
<script>
import AvatarCard from '@/components/AvatarCard'
import CoachCardNew from '@/components/CoachCardNew'
export default {
    name: 'CoachList',
    components: {
        AvatarCard,CoachCardNew
    },
    data(){
      return {
        list:{},  // 团课列表
        total:0   // 总数
      }
    },
    created(){
        // 取团课列表数据
        let _this = this;
        this.$http.post('club_coach/getCoachListByClub',{
            clubId:this.$route.params.clubId,
            status:'agreed'
        }).then(function(res){
            console.log(res)
          _this.list = res.data.value
          _this.total = res.data.value.length
        })
    }
}
</script>
<style lang="less">
.coach-list{
    &>.avatar-card{
        width: 48%;
        float: left;
        &:nth-child(odd){
            margin-right: 4%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/CoachList.vue